import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ShiftPlanListBubbleItemInterface, BaseInquiryShiftsWithFlex } from 'base';

@Component({
  selector: 'base-customer-shift-plan-bubble',
  templateUrl: './base-customer-shift-plan-bubble.component.html',
})
export class BaseCustomerShiftPlanBubbleComponent {
  @Input() bubble: ShiftPlanListBubbleItemInterface;
  @Input() isVisible = true;
  @Input() isCalendar = false;
  @Output() bubbleClick = new EventEmitter<BaseInquiryShiftsWithFlex>();

  bubbleClickHandler(selectedBubble: ShiftPlanListBubbleItemInterface) {
    this.bubbleClick.emit(selectedBubble.shift);
  }
}
